import React from 'react';
export const Telephone = () => (
  <div className="contact-button telephone-button">
    <svg
      width="48"
      height="48"
      className="contact-svg"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="m26.268 8-.205 6.234a3.495 3.495 0 0 0 2.078 3.288l2.565 1.119s-1.832 7.667-7.41 12.84c-.016 0-1.122-.824-2.163-1.602a3.366 3.366 0 0 0-3.746-.17l-5.486 3.373a1.921 1.921 0 0 0-.635 2.601l2.984 4.964c.801 1.333 2.428 1.751 3.962.938 3.64-1.93 10.539-6.007 15.29-14.873 3.628-6.768 3.6-14.158 3.256-17.978a2.944 2.944 0 0 0-2.862-2.65L28.371 6a2.092 2.092 0 0 0-2.103 2Z"
        fill="#FFF9F2"
      />
    </svg>
  </div>
);
